import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
function ContactUs() {
  return (
    <div className="contact-cotaniner">
    <div className='row gx-0 justify-content-between' style={{ rowGap: "15px" }}>
      <div className='col-lg-6 col-md-12 contactleftdiv'>
        <h5>Any Questions? </h5>
        <h5>Write or call us.</h5>
        <h5>We will write back with in few hours</h5>


        <p className='developement-title'>Directorate of Urban Administration & Development,</p>
        <p className='mb-0'>Madhya Pradesh</p>

        <div className='contactdiv'>
          <img src="img/Addresslocation.svg" alt='Address Location' />
          <h6>Office of The Commissioner, Third Floor, Palika Bhawan, Shivaji Nagar, Bhopal, Pin - 462016,</h6>
        </div>

        <div className='faxdiv'>
          <div className='contactdiv m-0'>
            <img src="img/telephone.svg" alt='Address Location' />
            <h6>+91 755 2575491</h6>
          </div>
          <img src="img/Linehead.png" alt='line' className='faxline' />
          <div className='contactdiv m-0'>
            <img src="img/FAX.svg" alt='Address Location' />
            <h6>+91 755 2575491</h6>
          </div>
        </div>
        <div className='contactdiv m-0'>
          <img src="img/mail.svg" alt='Address Location' />
          <h6>citizenhelpdesk@mpurban.gov.in</h6>
        </div>
      </div>
      <div className='col-lg-5 col-md-12'>
        <form className="contactform">
          <input type='text' className='form-control' placeholder='Enter your full name here' />
          <input type='text' className='form-control' placeholder='Enter your email address here' />
          <input type='text' className='form-control' placeholder='Enter your phone number' />
          <textarea className='form-control' placeholder='Enter your message here in 500 words'></textarea>
          <div className="capchadiv mt-2">
            <div className='captcha'>
              <ReCAPTCHA sitekey="6Lel4Z4UAAAAAOa8LO1Q9mqKRUiMYl_00o5mXJrR" 
                className='custom-recaptcha' 
                />
            </div>
            <button className="send-btn"><span className='gradient-text'>Send Message</span>
             {/* <img src="img/send.svg" /> */}
             <img src="img/send-new.svg" />
             </button>
          </div>
         
        </form>
      </div>
    </div>
  </div>
  )
}

export default ContactUs
